import React from 'react';

import SuggestedActionButton from './components/SuggestedActionButton';
import {
  ErrorMessage,
  SuggestedResponseButtonContainer,
  SuggestedResponseContainer,
} from './styled';

interface ISuggestedResponseState {
  options: string[];
  suggestedActionError: string;
  selectedOption: string;
}

interface ISuggestedResponseProps {
  value?: string[];
  onChange: (responses: string[]) => void;
}

class SuggestedResponse extends React.Component<ISuggestedResponseProps, ISuggestedResponseState> {
  constructor(props: ISuggestedResponseProps) {
    super(props);
    this.state = {
      options: props.value || [],
      suggestedActionError: '',
      selectedOption: '',
    };
  }

  public componentDidUpdate(prevProps: ISuggestedResponseProps, prevState: ISuggestedResponseState) {
    const { options } = this.state;
    const current = JSON.stringify(options);
    const prev = JSON.stringify(prevState.options);
    if (current !== prev) {
      const index = options.findIndex(i => i === '');
      const updateOptions = options.slice();
      if (index > -1) {
        updateOptions.splice(index, 1);
      }
      this.props.onChange(updateOptions);
    }
  }

  public render() {
    const { options, selectedOption, suggestedActionError } = this.state;
    const optionsExist = options && options.length > 0;

    return (
      <>
        <SuggestedResponseContainer
          id='suggested-responses'
          onClick={() => this.createBlankInputBubble()}
        >
          {optionsExist && <label htmlFor='suggested-responses'>
            Suggested Responses:
        </label>}

          <SuggestedResponseButtonContainer>
            {optionsExist ? options.map(response =>
              <SuggestedActionButton
                response={response}
                showErrorMessage={this.showSuggestedActionErrorMessage}
                existingActions={options || []}
                addSuggestedAction={this.addSuggestedAction}
                deleteSuggestedAction={this.deleteSuggestedAction}
                updateSuggestedAction={this.updateSuggestedAction}
                setSelectedInput={this.setSelectedInput}
                selectedOption={selectedOption}
              />,
            )
              : <p>{'Add a Suggested Response'}</p>}
          </SuggestedResponseButtonContainer>
        </SuggestedResponseContainer>
        <ErrorMessage>{suggestedActionError}</ErrorMessage>
      </>
    );
  }

  public showSuggestedActionErrorMessage = (value: boolean) => {
    let errorMessage = '';
    if (value) {
      errorMessage = '* This suggested response already exists.';
    }
    this.setState({
      suggestedActionError: errorMessage,
    });
  }

  private setSelectedInput = (value: string) => {
    this.setState({ selectedOption: value });
  }

  // the following methods are all for the suggested action bubbles
  private createBlankInputBubble = () => {
    const { options } = this.state;
    const updatedOptions = options.slice();
    if (!updatedOptions.includes('')) {
      updatedOptions.push('');
      this.setState({
        options: updatedOptions,
      });
    }
  }

  private addSuggestedAction = (suggestion: string) => {
    const { options } = this.state;
    // put the input text in the array where the empty space was waiting
    options![options!.indexOf('')] = suggestion;
    const removeDuplicates: Set<string> = new Set(options);
    const newOptions = Array.from(removeDuplicates);
    this.setState({
      options: newOptions,
    });
    this.createBlankInputBubble();
    this.setSelectedInput('');
  }

  private deleteSuggestedAction = (response: string) => {
    const { options } = this.state;
    const updatedOptions = options.filter(action => response !== action);
    this.setState({
      options: updatedOptions,
    });
  }

  private updateSuggestedAction = (newValue: string, oldValue: string) => {
    const { options } = this.state;
    const i = options.findIndex(c => c === oldValue);
    const removeDuplicates: Set<string> = new Set(options);
    const newoptions = Array.from(removeDuplicates);
    newoptions[i] = newValue;
    this.setState({ options: newoptions, selectedOption: '' });
  }

}

export default SuggestedResponse;
